/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { createFieldValueMappingRequestSchema } from './createFieldValueMappingRequestSchema';

export const saveFieldValueMappingsRequestSchema = z.object({
  get mappings() {
    return z.array(createFieldValueMappingRequestSchema);
  },
});
